<template>
    <div class="avatar-wrapper">
        <v-avatar :size="size">
            <img :src="avatarImageURL" alt="avatar" />
        </v-avatar>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "ChatAvatar",
        props: {
            size: {
                type: Number,
                default: () => 48,
            },
            role: {
                type: String,
                required: true,
            }
        },
        computed: {
            ...mapGetters(["user"]),
            avatarImageURL() {
                switch (this.role) {
                    case this.$const.CHAT_MESSAGE_ROLE__USER:
                        return this.userAvatar;
                        
                    case this.$const.CHAT_MESSAGE_ROLE__ASSISTANT:
                        return this.assistantAvatar

                    default:
                        return this.defaultAvatar;
                }
            },
            userAvatar() {
                if (this.user.isLoaded && this.user.userAvatarImage) {
                    return this.user.userAvatarImage;
                }

                return this.defaultAvatar;
            },
            assistantAvatar() {
                return "/ezoic-48x48.png";
            },
            defaultAvatar() {
                return this.$const.DEFAULT_AVATAR;
            },
        },
    }
</script>